import { render, staticRenderFns } from "./TestLanguage.vue?vue&type=template&id=1fd54d29&scoped=true&"
import script from "./TestLanguage.vue?vue&type=script&lang=js&"
export * from "./TestLanguage.vue?vue&type=script&lang=js&"
import style0 from "./TestLanguage.vue?vue&type=style&index=0&id=1fd54d29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd54d29",
  null
  
)

export default component.exports